<span class="btn btn-info btn-sm"
      ng-show="ecCtrl.consult.examinations.length"
      popover-trigger="outsideClick"
      uib-popover-template="ecCtrl.popover"
      popover-title="Kommentare/Anmerkungen der Untersuchungen"
      popover-placement="auto top">Anmerkungen der U.</span>


<script type="text/ng-template" id="examcomments_popver.tpl.html">
  <div>
    <div ng-repeat="exam in ecCtrl.consult.examinations | filter: {active: true}">
      <h4 ng-bind="exam.type"></h4>
      <span ng-repeat="val in exam.template.comment.avalues">{{val.name}}{{$last ? '' : ', '}}</span>
    </div>

    <p class="alert alert-warning" style="margin-top: 10pt;">
      Die Kommentare der einzelnen Untersuchungen werden NICHT automatisch in den Gesamtbefund/Arztbrief übernommen.
    </p>

  </div>
</script>